const resultInfo = {
    type: [
        {
            index: 0,
            name: '불안형',
            nick: '강아지',
            image: 'problem',
            type: 0,
            future: true,
            conflict: true,
        }, {
            index: 1,
            name: '불안형',
            nick: '강아지',
            image: 'problem',
            type: 0,
            future: true,
            conflict: false,
        }, {
            index: 2,
            name: '불안형',
            nick: '강아지',
            image: 'problem',
            type: 0,
            future: false,
            conflict: true,
        }, {
            index: 3,
            name: '불안형',
            nick: '강아지',
            image: 'problem',
            type: 0,
            future: false,
            conflict: false,
        }, {
            index: 4,
            name: '회피형',
            nick: '고양이',
            image: 'avoid',
            type: 1,
            future: true,
            conflict: true,
        }, {
            index: 5,
            name: '회피형',
            nick: '고양이',
            image: 'avoid',
            type: 1,
            future: true,
            conflict: false,
        }, {
            index: 6,
            name: '회피형',
            nick: '고양이',
            image: 'avoid',
            type: 1,
            future: false,
            conflict: true,
        }, {
            index: 7,
            name: '회피형',
            nick: '고양이',
            image: 'avoid',
            type: 1,
            future: false,
            conflict: false,
        }
    ],
    main_results: [
        {
            favorites: [{
                order: 1,
                text: '왜 이렇게 연락을 안받지? 혹시 바람피는거 아니야?',
            }, {
                order: 2,
                text: '핸드폰을 왜 뒤집어 놓지?<br/>혹시 다른 사람과 연락하는거 아니야?',
            }, {
                order: 3,
                text: '친구들과 1박 2일로 여행을 어떻게 갈 수 있어?',
            }, {
                order: 4,
                text: '왜 읽고 바로 답장을 안해?',
            }, {
                order: 5,
                text: '인스타는 하면서 카톡은 왜 답장을 안해주는거야?',
            }, {
                order: 6,
                text: '너는 나를 사랑하지 않는것 같아. 우리 헤어져!',
            }, {
                order: 7,
                text: '나에 대해 관심이나 있긴해?',
            }, {
                order: 8,
                text: '나는 만나고 있는 순간에도 외로웠어!',
            }, {
                order: 9,
                text: '오늘이 무슨 날인지 알아?<br/>그런데 어떻게 꽃도 준비안할 수가 있어?',
            }, {
                order: 10,
                text: '언제는 서운한거 있으면 다 말하라고 해놓고<br/>왜 이제와서 그래?',
            }],
            features: [{
                order: 1,
                html: '<span class="first">사</span>랑이 인생에서 얼마나 소중한지 알고 있는 당신. ' +
                    '당신은 <span class="emphasis">낭만적이고 로맨틱한 사랑</span>을 꿈꿉니다. ' +
                    '사랑하는 연인과 마음 깊이 연결되고, 둘만의 끈끈한 결속감을 중요하게 생각하죠. ' +
                    '<span class="emphasis">진실한 사랑은 쉽게 오지 않는다고 생각하면서도, 소울메이트를 만나 영원한 사랑에 빠지고 싶은 열망</span>을 가지고 있어요.',
            }, {
                order: 2,
                html: '<span class="left">또</span>한 당신은 사랑을 위해 최선을 다하고 싶어 하기 때문에 고민도 많이 하고 공부를 하기도 해요. ' +
                    '친구들과 연애상담을 하기도 하고요. 이렇게 나름대로 노력을 하기에 연인에게도 나와 같은 마음으로 최선을 다해주기를 기대하는 마음이 있죠. ' +
                    '그러다 보니 때로는 의도와 다르게 연인이 나에게 서운함을 느끼기도 해요. 살다 보면 힘든 일, 스트레스받는 상황들이 있는데 그럴 때조차 당신은 연인에게 언제나 1순위이기를 바라거든요.',
            }, {
                order: 3,
                html: '<span class="emphasis"><span class="left">자</span>꾸만 연인에게 확인받고 싶고, 의지하고 싶고, 원하게 되는 것들이 많다 보니까</span> 그런 당신의 모습이 스스로 마음에 들지 않을 때도 있어요. ' +
                    '그럴 때는 겉으로 괜찮은 척 거리를 두기도 하죠. ' +
                    '사랑이 참 어렵게 느껴지죠? 앞으로 당신은 중심을 잘 유지해야 해요. ' +
                    '그러기 위해서 무엇을 할 수 있을지, <span class="emphasis">행복한 사랑을 위해서 당신에게 어떤 것들이 필요할지 찾아보세요!</span>',
            }]
        },
        {
            favorites: [{
                order: 1,
                text: '나에게 왜 이렇게 바라는게 많지?',
            }, {
                order: 2,
                text: '나만의 시간이 필요해',
            }, {
                order: 3,
                text: '왜 나를 고치려고 하지?',
            }, {
                order: 4,
                text: '내 노력은 봐주지도 않는구나..',
            }, {
                order: 5,
                text: '상대는 너무 감정적이야. 이성적으로 생각 좀 해!',
            }, {
                order: 6,
                text: '아 알았어. 나중에 얘기하자',
            }],
            features: [{
                order: 1,
                html: '<span class="first">사</span>랑도 필요하지만 자신의 삶이 가장 중요하다고 여기는 당신. ' +
                    '당신은 <span class="emphasis">자유로운 영혼이 되고 싶은 사람</span>이에요. ' +
                    '연인과 친밀하기를 원하면서도 어느 정도의 거리를 유지하려고 하죠. ' +
                    '연인과 <span class="emphasis">지나치게 가까워졌을 때 자신의 본질적인 모습을 잃게 될까 하는 두려움</span>을 느끼기 때문이에요. ' +
                    '그러다 보니 연애보다 내 삶이 우선이고, 스트레스받거나 문제 상황이 생겼을 때 의지하지 않고 <span class="emphasis">자기 혼자만의 힘으로 이겨내고자 하는 독립적인 모습</span>을 보여요.',
            }, {
                order: 2,
                html: '<span class="left">연</span>인의 입장에서는 이런 당신이 혼란스럽기도 해요. <span class="emphasis">벽이 있는 것 같고</span>, ' +
                    '당신의 마음속에 자신이 중요한 사람으로 여겨지고 있는지 확인받고 싶은 불안감이 생기기도 하죠. ' +
                    '그래서 당신에게 서운함을 털어놓을 수도 있는데, 당신은 연인의 감정을 얼마나 공감해 주고 품어주었나요?',
            }, {
                order: 3,
                html: '<span class="left">당</span>신도 따뜻한 사랑을 원하는 사람입니다. ' +
                    '<span class="emphasis">누군가와 진정으로 가까워질 능력이 스스로에게 없다고 생각하나요?</span> ' +
                    '당신이 사랑하는 연인의 마음을 돌보기 위해서 앞으로 어떤 행동과 어떤 태도를 가져야 하는지 곰곰이 생각해보세요!',
            }]
        },
    ],
    sub_results: [[
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 생각과 감정을 잘 알아차리고, 연인의 행동과 동기를 이해할 수 있어요. 이렇게 상대방의 입장에서 생각할 수 있는 능력은 관계 유지에 아주 중요한 요소예요. 크고 작은 갈등 상황에서 연인의 입장을 이해하면서 대화를 나눌 수 있으므로, 더욱 적응적이고 긍정적인 갈등해결이 가능하죠.',
        }, {
            order: 2,
            html: '<span class="left">다</span>만 당신은 연인의 행동이나 감정이 당신이 기대하던 수준에 미치지 못할 때 서운함과 불안함을 자주 느낄 수 있어요. 이럴 경우 ‘사랑받음’에 대한 자기가치감이 낮아지기 때문에, 자기 자신에게 집중하기보다는 <span class="emphasis">연인의 관심이나 스트레스를 돌보는 것에 과도하게 집중하게 돼서</span> 당신 자신을 뒷전으로 두게 될 수 있어요. 그러다 보면 다시 <span class="emphasis">서운함이 쌓이는 악순환의 고리</span>에 갇히게 됩니다.',
        }, {
            order: 3,
            html: '<span class="left">따</span>라서 성숙하고 건강한 관계를 유지하기 위해서 당신의 삶에 집중하고,<span class="emphasis"> 자신의 감정과 욕구를 알아차리고,</span> 그걸 <span class="emphasis">연인에게 오해되지 않도록 적절히 표현하는 화법</span>이 필요할 거예요. 만약 연인의 마음이 이해가 잘 안되고, 어디서부터 어떻게 풀어야 할지 모르겠다면, 당신과 연인에 대한 상호 이해를 기반으로 한 분석이 중요하겠죠!',
        }
    ], [
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 생각과 감정을 잘 알아차리고, 연인의 행동과 동기를 이해할 수 있어요. 이렇게 상대방의 입장에서 생각할 수 있는 능력은 관계 유지에 아주 중요한 요소예요. 크고 작은 갈등 상황에서 연인의 입장을 이해하면서 대화를 나눌 수 있으므로, 더욱 적응적이고 긍정적인 갈등해결이 가능하죠.',
        }, {
            order: 2,
            html: '<span class="left">다</span>만 당신은 연인의 행동이나 감정이 <span class="emphasis">당신이 기대하던 수준에 미치지 못할 때 서운함과 불안함</span>을 자주 느낄 수 있어요. 이럴 경우 ‘사랑받음’에 대한 자기가치감이 낮아지기 때문에, 자기 자신에게 집중하기보다는 연인의 관심이나 스트레스를 돌보는 것에 과도하게 집중하게 돼서 당신 자신을 뒷전으로 두게 될 수 있어요. 그러다 보면 <span class="emphasis">다시 서운함이 쌓이는 악순환의 고리</span>에 갇히게 됩니다.',
        }, {
            order: 3,
            html: '<span class="left">당</span>신은 민감하게 감정과 문제를 인식할 수는 있지만, 적응적으로 해소하고 해결하는 방법은 서툴러요. <span class="emphasis">무조건 맞춰주고 희생하거나, 문제가 없는 척 해결을 뒤로 미루는 건</span> 건강한 방법이 아니죠. 또 당신이 원하는 행복을 얻는 것도 중요하고요. 당신도 만족하고 행복해야만 우리 연애가 더 오래오래 건강하게 지속될 수 있겠죠?',
        }
    ], [
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 입장을 이해하는 능력이 낮은 편이에요. 연인의 행동과 동기, 감정 등을 이해하기 어려워하기 때문에 <span class="emphasis">당신이 받기를 기대하는 수준에 미치지 못할 경우 서운함과 불안함</span>을 느끼게 되고, 이런 감정들이 반복적으로 느껴지면서 ‘문제’라고 인식을 하게 되죠. 문제를 인식하게 되면 당신의 머릿속에는 빨간불이 켜지고, 문제를 빨리 해결하고 싶어해요.',
        }, {
            order: 2,
            html: '<span class="left">다</span>만 당신이 어떻게 느끼고 어떻게 생각하는지 오해되지 않도록 표현하는 방법이나, 정서적으로 연인을 공감하는 방법 등이 서툴다 보니, \'문제해결책\'에만 초점을 맞출 수 있어요. 친밀한 감정을 나누는 연인 관계에서는 객관적인 문제 해결보다 <span class="emphasis">정서적인 교류가 우선 되어야 하죠.</span> 연인의 입장에서는 당신에게 <span class="emphasis">공감 받고 수용 받고 싶은 욕구가 좌절될 때마다 서운함을 느낄 수 있어요.</span>',
        }, {
            order: 3,
            html: '<span class="left">그</span>렇기 때문에 당신은 자신의 감정과 생각을 적절히 표현할 수 있는 화법을 배우고, 연인이 경험하는 삶과 상황을 있는 그대로 인정해 주고 이해해 주는 태도를 개발시켜나가는 것이 필요할 거예요.',
        }
    ], [
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 입장을 이해하는 능력이 낮은 편이에요. 연인의 행동과 동기, 감정 등을 이해하기 어려워하기 때문에 당신이 받기를 기대하는 수준에 미치지 못할 경우 서운함과 불안함을 자주 느끼죠. 이런 감정들이 쌓이고 쌓이면 <span class="emphasis">연인에게 일방적으로 당신의 감정에 맞춰서 보살펴달라고 요구하거나, 혹은 아무런 문제가 없는 척 숨기기도 해요.</span>',
        }, {
            order: 2,
            html: '<span class="left">우</span>리 관계가 뭔가 삐거덕거리고 있는 거 같은데 어떻게 말해야 할지, 어떻게 해결해야 할지 잘 모르기 때문에 <span class="emphasis">더 조심스러워지고 더 심각하게 느껴져요.</span> 당신도 그렇고 연인도 마찬가지로 우리의 사랑이 행복하고 편안하기보다는 어렵고 힘들게 느껴지죠.',
        }, {
            order: 3,
            html: '<span class="left">잘</span> 풀고 싶지만 방법을 모르기 때문에 많이 답답할 거예요. 일단 연인의 입장을 생각할 수 있는 능력을 기르고, 갈등을 성장과 변화를 위한 기회로 인지할 수 있는 긍정성도 필요하고요. 또 연인과의 관계에서 당신이 원하는 결과를 이루기 위해 <span class="emphasis"> 효과적으로 의사소통하고 차근히 갈등을 해결하는 방법</span>을 배우는 게 필요할 거예요.',
        }
    ], [
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 생각과 감정을 잘 알아차리고, 연인의 행동과 동기를 이해할 수 있어요. 이렇게 상대방의 입장에서 생각할 수 있는 능력은 관계 유지에 아주 중요한 요소예요. 크고 작은 갈등 상황에서 연인의 입장을 이해하면서 대화를 나눌 수 있으므로, 더욱 적응적이고 긍정적인 갈등해결이 가능하죠.',
        }, {
            order: 2,
            html: '<span class="left">다</span>만 당신은 스트레스에 약하기 때문에, 당신의 에너지 수준이 낮아질 때는 연인의 입장을 먼저 헤아리려 하는 동기가 낮아져요. 그래서 <span class="emphasis">일부러 무관심한 태도를 취하거나 관계에서 한발 거리를 두고 물러나는 등의 회피적인 행동</span>을 하기도 하죠. 그럴 때 연인은 다시 서운함을 느끼게 돼서, 당신이 관계를 위한 노력을 소홀히 한다는 원망을 하게 되고, 그럼 <span class="emphasis">당신은 또다시 스트레스를 느끼게 되는 악순환</span>에 빠질 수 있어요.',
        }, {
            order: 3,
            html: '<span class="left">그</span>렇기에 우선 당신의 내적/외적인 환경을 안정적으로 잘 케어하고 돌보는 것이 중요해요. 다만 당신도 어쩔 수 없는 상황들이 있을 수 있는데, 그럴 때 당신이 자꾸만 피하려 하지는 않는지, 연인을 서운하게 만들고 있지는 않은지 돌아보아야 해요. 그런 순간에 <span class="emphasis">소중한 연인의 감정을 어떻게 지켜줄 수 있을지, 어떤 말을 해줘야 하는지 꼭 고민해보시구요!</span>',
        }
    ], [
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 생각과 감정을 잘 알아차리고, 연인의 행동과 동기를 이해할 수 있어요. 이렇게 상대방의 입장에서 생각할 수 있는 능력은 관계 유지에 아주 중요한 요소예요. 다만 당신은 갈등 상황에서 정서적인 반응을 나누는 것을 불편하게 느끼고 특히 스트레스 상황에서는 연인의 입장을 먼저 헤아리려는 동기가 낮아져요. 그냥 좋은 게 좋은 거다-로 빨리 상황을 마무리하고 싶어 하죠.',
        }, {
            order: 2,
            html: '<span class="left">어</span>떻게 상황을 잘 풀어갈 수 있을지 감이 잡히지 않으니, 연인과의 갈등을 더욱 버겁게 느껴서 다양한 방법으로 <span class="emphasis">갈등과 연인에게서 거리를 두고 물러나려는 회피적인 행동</span>을 하기도 해요. 이 모든 건 당신 나름대로 연인과의 관계를 유지하고자 하는 노력이지만, <span class="emphasis">연인에게 그 숨겨진 의도가 잘 전달되기는 어렵죠.</span> ',
        }, {
            order: 3,
            html: '<span class="left">좀</span> 더 용기를 가지고 갈등을 성장과 변화를 위한 기회로 생각할 수 있어야 해요. 그리고 앞으로 연인에게 <span class="emphasis"> 당신이 느끼는 감정을 안전하게 전달하는 화법</span>과 <span class="emphasis">갈등을 긍정적인 방향으로 차근히 해결하는 방법</span>을 배우고 개발해나가는 게 필요할 거예요.',
        }
    ], [
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 입장을 이해하는 능력이 낮아서 연인의 행동과 동기, 감정 등을 이해하기 어려워요. 관계보다도 당신의 삶이 우선이 되어야 한다고 생각하기 때문에 연인의 입장에서 감정을 공감하고 수용하려는 의지도 낮은 편이고요. 특히 이런 점은 연인 사이에서 갈등이 생겼을 때 부정적인 영향을 미치게 되죠.',
        }, {
            order: 2,
            html: '<span class="left">당</span>신은 갈등을 적극적으로 해결하고 싶어하지만 연인을 정서적으로 품어주고 따뜻하게 안아주기보다, <span class="emphasis">객관적-이성적으로 문제를 해결하려 하기</span>에 연인은 <span class="emphasis">서운함</span>을 느끼게 되죠.',
        }, {
            order: 3,
            html: '<span class="left">기</span>억해 주세요. 친밀한 감정을 나누는 연인 관계에서는 객관적인 문제 해결보다 <span class="emphasis"> 정서적 교류와 \'내 편\'이라는 신뢰가 우선 되어야 하고, </span> 서로에게 <span class="emphasis">안정적인 존재</span>가 되어주어야 한다는 사실을! 그래야 갈등을 해결할 에너지가 생기고 당신이 원하는 해결책에 도달할 수 있겠죠? 당신은 <span class="emphasis">이제부터 연인이 경험하는 삶과 상황을 있는 그대로 인정해 주고 이해해 주는 태도</span>를 개발시켜나가는 것이 필요할 거예요.',
        }
    ], [
        {
            order: 1,
            html: '<span class="first">당</span>신은 연인의 입장을 이해하는 능력이 낮아서 연인의 행동과 동기, 감정 등을 이해하기 어려워요. 그리고 연인 관계보다도 당신의 삶이 우선이 되어야 한다고 생각하기 때문에 연인의 입장에서 감정을 공감하고 수용하려는 의지도 낮은 편이고요. 특히 이런 점은 연인 사이에서 갈등이 생겼을 때 부정적인 영향을 미치게 되죠.',
        }, {
            order: 2,
            html: '<span class="left">그</span>러다 보니 연인과의 갈등을 더욱 버겁게 느끼기도 하고, 다양한 방법으로 갈등과 연인에게서 거리를 두고 물러나려는 회피적인 행동을 하기도 해요. 이 모든 건 당신 나름대로 연인과의 관계를 유지하고자 하는 노력이지만, <span class="emphasis">연인에게 그 숨겨진 의도가 잘 전달되기는 어려워요.</span>',
        }, {
            order: 3,
            html: '<span class="left">당</span>신은 좀 더 용기를 가지고 갈등을 성장과 변화를 위한 기회로 생각할 수 있어야 해요. 그리고 사랑하는 <span class="emphasis">연인이 어떤 감정을 느낄지, 어떤 욕구를 가지고 있을지</span> 등 연인의 마음을 이해 할 수 있는 능력도 길러야 하고요. 그 이해를 기반으로 연인에게 <span class="emphasis">당신의 생각 또는 감정을 안전하게 전달하고,</span> 우리 관계에서의 <span class="emphasis">갈등을 긍정적인 방향으로 해결하는 방법</span>을 배우고 개발해나가는 게 필요할 거예요.',
        }
    ]],
};

export default resultInfo;
